import React from 'react';
import clone from 'clone';
import classNames from 'classnames';

class RadioBox extends React.Component {
  constructor(props) {
    super(props);
    this.handleRadioBox = this.handleRadioBox.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
  }
  componentWillMount() {

  }
  handleRadioBox(e) {
    // console.log(e.target);
    const values = [];
    this.options.forEach((item) => {
      if (item.key === parseInt(e.target.value, 10)) {
        item.isChecked = e.target.checked;
        values.push(item);
      }
    });
    // console.log(values);
    this.props.onSelectRadio(values);
  }
  handleLoad(type, e) {
    e.preventDefault();
    this.props.onHandleShowMore(type);
  }
  render() {
    this.options = clone(this.props.options);
    // console.log(this.props);
    this.options.map((item) => {
      if (this.props.value.indexOf(item.slug) !== -1) {
        item.isChecked = true;
      } else {
        item.isChecked = false;
      }
    });
    const singleRadioBoxItem = (item, index) => {
      return (
        <span className="single-input searchoption" key={'radio-' + index}>

          <input type="radio" id={item.slug + '-' + this.props.block.uid} checked={item.isChecked} value={item.key} onChange={this.handleRadioBox}/>
          <label className="" htmlFor={item.slug + '-' + this.props.block.uid}><span className="rq-search-text">{item.value}</span>
            {this.props.showNumberOfItems === 'true' ? <span className="pull-right rq-number-of-product">{item.count}</span> : ''}
          </label>
        </span>
        );
    };
    const childInputClass = classNames('input-container', this.props.isOpenElement);
    let setColumnStyle = null;
    if (this.props.setColumn === '1') {
      setColumnStyle = 'radio-input-content';
    } else if (this.props.setColumn === '2') {
      setColumnStyle = 'radio-input-content split';
    } else if (this.props.setColumn === '3') {
      setColumnStyle = 'radio-input-content split-2';
    } else if (this.props.setColumn === '4') {
      setColumnStyle = 'radio-input-content split-3';
    }
    const options = [];
    let showItem = this.props.showItem;
    for (let key = 0; key < showItem; key++) {
      options.push(this.options[key]);
    }
    return (
      <div className={childInputClass}>
        <span className={setColumnStyle}>
          { this.options.length ? options.map(singleRadioBoxItem) : null }
        </span>
        {this.props.showLoadLessBlock === true ? <div>
          {
            this.props.showLoadMore === true ? <a className="show-less-btn" href="#" onClick={this.handleLoad.bind(this, 'more')}>Show More</a> : <a className="show-less-btn" href="#" onClick={this.handleLoad.bind(this,'less')}>Show Less</a>
          }
        </div> : null}
      </div>
    );
  }
}

RadioBox.propTypes = {
  'value': React.PropTypes.array,
  'options': React.PropTypes.array,
  'onSelectRadio': React.PropTypes.func,
  'isOpenElement': React.PropTypes.string,
  'showNumberOfItems': React.PropTypes.string,
  'setColumn': React.PropTypes.string,
  'block': React.PropTypes.object,
};

export default RadioBox;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/element/radiobox.js
 **/